//condicionales op importaciones exportaciones

document.addEventListener('DOMContentLoaded', function() {

    $('.cat__importaciones').click(function() {
        $('.subcat__62').css('display', 'flex');
        $('.subcat__63').css('display', 'flex');
        $('.subcat__64').css('display', 'flex');
        $('.subcat__65').css('display', 'flex');
        $('.subcat__66').css('display', 'flex');
        $('.subcat__67').css('display', 'flex');
        $('.subcat__68').css('display', 'flex');
        $('.subcat__69').css('display', 'flex');
        $('.subcat__70').css('display', 'flex');
        $('.subcat__71').css('display', 'flex');
        $('.subcat__72').css('display', 'flex');
        $('.subcat__73').css('display', 'flex');
        $('.subcat__74').css('display', 'flex');
        $('.subcat__75').css('display', 'flex');
        $('.subcat__76').css('display', 'flex');
        $('.cat__importaciones').hide();
        $('.cat__exportaciones').hide();
        $('.cat__otherservice').hide();
        $('.navlink__volver').show();
    });

    $('.cat__exportaciones').click(function() {
        $('.subcat__83').css('display', 'flex');
        $('.subcat__84').css('display', 'flex');
        $('.subcat__85').css('display', 'flex');
        $('.subcat__86').css('display', 'flex');
        $('.subcat__87').css('display', 'flex');
        $('.subcat__88').css('display', 'flex');
        $('.subcat__89').css('display', 'flex');
        $('.subcat__90').css('display', 'flex');
        $('.subcat__91').css('display', 'flex');
        $('.subcat__92').css('display', 'flex');
        $('.subcat__93').css('display', 'flex');
        $('.subcat__94').css('display', 'flex');
        $('.subcat__95').css('display', 'flex');
        $('.subcat__96').css('display', 'flex');
        $('.subcat__97').css('display', 'flex');
        $('.cat__importaciones').hide();
        $('.cat__exportaciones').hide();
        $('.cat__otherservice').hide();
        $('.navlink__volver').show();
    });

    $('.cat__otherservice').click(function() {
        $('.subcat__1').css('display', 'flex');
        $('.subcat__79').css('display', 'flex');
        $('.subcat__82').css('display', 'flex');
        $('.subcat__98').css('display', 'flex');
        $('.subcat__99').css('display', 'flex');
        $('.subcat__101').css('display', 'flex');
        $('.cat__importaciones').hide();
        $('.cat__exportaciones').hide();
        $('.cat__otherservice').hide();
        $('.navlink__volver').show();
    });

    $('.navlink__volver').click(function() {
        $('[class*="subcat__"]').hide();
        $('.cat__importaciones').show();
        $('.cat__exportaciones').show();
        $('.cat__otherservice').show();
        $('.navlink__volver').hide();
    });

});

document.addEventListener('DOMContentLoaded', function() {
  var numeroIntencionInput = document.getElementById('numero_intencion');
  var anioActual = new Date().getFullYear();
  var rangoMinimo = (anioActual - 1) * 10000000;
  var rangoMaximo = (anioActual + 1) * 10000000 + 9999999;
  var errorDiv = document.getElementById('error_numero_intencion');

  numeroIntencionInput.addEventListener('input', function() {
      var numeroIntencion = parseInt(numeroIntencionInput.value);
      if (isNaN(numeroIntencion) || numeroIntencion < rangoMinimo || numeroIntencion > rangoMaximo) {
          errorDiv.innerHTML = 'El número debe estar comprendido entre ' + rangoMinimo + ' y ' + rangoMaximo + '.';
          numeroIntencionInput.setCustomValidity('El número debe estar comprendido entre ' + rangoMinimo + ' y ' + rangoMaximo + '.');
      } else {
          errorDiv.innerHTML = '';
          numeroIntencionInput.setCustomValidity('');
      }
  });
});
